export default __webpack_public_path__ + "static/media/white-logo.dfd80715.svg";